export const exportActionTypes = {
  CHOOSE_DEVICE_FORMAT: 'choose_device_format',
  EXPORT_TO_AFFILIATE: 'export_to_affiliate',
  DOWNLOAD_PREFERRED_DEVICE_FORMAT: 'download_preferred_device_format',
  SEND_TO_DRIVE: 'send_to_drive',
  CREATE_WORK_PLAN: 'create_work_plan'
};

export const exportScopeTypes = {
  FIELD: 'field',
  OPERATION: 'operation'
};

export const exportPrimaryStatusTypes = {
  PRIMARY: 'primary',
  ALL: 'all'
};

export const optionSelected = {
  SEND_TO_DRIVE: 'send_to_drive'
};
